import { BuilderComponent } from '@builder.io/react'

import { BUILDER_PAGE_MODEL } from '@/config/builder'

import { AdsBottom } from '../AdsBottom'
import { MostViewedArticlesSection, LatestArticlesSection } from '../ArticleSections'
import type { BlogLayoutProps } from '../BlogLayout'

export function ProductBlogLayout({
  product,
  content,
  mostViewedArticles,
  latestArticles,
  adsBottom,
}: BlogLayoutProps) {
  return (
    <>
      <BuilderComponent
        model={BUILDER_PAGE_MODEL}
        content={content}
        options={{ includeRefs: true }}
      />

      <MostViewedArticlesSection mostViewedArticles={mostViewedArticles} product={product} />
      <LatestArticlesSection latestArticles={latestArticles} product={product} />

      <AdsBottom adsBottom={adsBottom} />
    </>
  )
}
